import * as React from "react";
import { TransformGroup } from "./TransformGroup";

const Right = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.06075 2.59107C5.28655 2.34853 5.6662 2.33496 5.90874 2.56075C6.44464 3.05966 7.70463 4.31989 8.81966 5.44395C9.37962 6.00845 9.90665 6.54229 10.2937 6.93496C10.4872 7.13131 10.6457 7.2924 10.7559 7.40443L10.9273 7.57876L10.4999 7.9999L10.928 8.42034L10.7559 8.59538C10.6457 8.70741 10.4872 8.8685 10.2937 9.06485C9.90665 9.45752 9.37962 9.99136 8.81966 10.5559C7.70463 11.6799 6.44464 12.9402 5.90874 13.4391C5.6662 13.6648 5.28655 13.6513 5.06075 13.4087C4.83496 13.1662 4.84853 12.7865 5.09107 12.5608C5.60526 12.0821 6.84527 10.8423 7.96772 9.71076C8.52649 9.14745 9.05257 8.61459 9.43899 8.22251C9.51828 8.14206 9.59169 8.06754 9.65828 7.9999C9.59169 7.93227 9.51828 7.85775 9.43899 7.7773C9.05257 7.38522 8.52649 6.85236 7.96772 6.28905C6.84527 5.15751 5.60526 3.91775 5.09107 3.43906C4.84853 3.21326 4.83496 2.83361 5.06075 2.59107ZM10.4999 7.9999L10.928 8.42034C11.1572 8.18694 11.1572 7.81292 10.928 7.57952L10.4999 7.9999Z"
    />
);

const Left = () => (
    <TransformGroup rotation="reverse">
        <Right />
    </TransformGroup>
);

const Down = () => (
    <TransformGroup rotation="rotate90deg">
        <Right />
    </TransformGroup>
);

const Up = () => (
    <TransformGroup rotation="rotate270deg">
        <Right />
    </TransformGroup>
);

const RightSmall = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.06075 4.59107C6.28655 4.34853 6.6662 4.33496 6.90874 4.56075C7.23462 4.86414 7.99461 5.62437 8.66215 6.29731C8.99836 6.63625 9.31477 6.95675 9.54709 7.19247L9.92756 7.57906L9.4999 7.9999L9.92798 8.42033L9.54709 8.80734C9.31477 9.04306 8.99836 9.36356 8.66215 9.7025C7.99461 10.3754 7.23462 11.1357 6.90874 11.4391C6.6662 11.6648 6.28655 11.6513 6.06075 11.4087C5.83496 11.1662 5.84853 10.7865 6.09107 10.5608C6.39524 10.2776 7.13525 9.53782 7.8102 8.8574C8.12894 8.53608 8.42995 8.23126 8.65802 7.9999C8.42995 7.76855 8.12894 7.46373 7.8102 7.14241C7.13525 6.46199 6.39524 5.72223 6.09107 5.43906C5.84853 5.21326 5.83496 4.83361 6.06075 4.59107ZM9.4999 7.9999L9.92798 8.42033C10.1572 8.18692 10.1568 7.81246 9.92756 7.57906L9.4999 7.9999Z"
    />
);

const LeftSmall = () => (
    <TransformGroup rotation="reverse">
        <RightSmall />
    </TransformGroup>
);

const DownSmall = () => (
    <TransformGroup rotation="rotate90deg">
        <RightSmall />
    </TransformGroup>
);

const UpSmall = () => (
    <TransformGroup rotation="rotate270deg">
        <RightSmall />
    </TransformGroup>
);

const CollapseUp = () => (
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.42029 3.32192L7.9999 3.75002L7.57952 3.32192C7.81292 3.09273 8.18689 3.09273 8.42029 3.32192ZM7.9999 4.59191C8.23126 4.81998 8.53608 5.12099 8.8574 5.43973C9.53782 6.11468 10.2776 6.85469 10.5608 7.15886C10.7865 7.4014 11.1662 7.41497 11.4087 7.18918C11.6513 6.96338 11.6648 6.58373 11.4391 6.34119C11.1357 6.01531 10.3754 5.25532 9.7025 4.58778C9.36356 4.25157 9.04306 3.93516 8.80734 3.70284L8.42029 3.32192L7.9999 3.75002L7.57952 3.32192L7.19247 3.70284C6.95675 3.93516 6.63625 4.25157 6.29731 4.58778C5.62437 5.25532 4.86414 6.01531 4.56075 6.34119C4.33496 6.58373 4.34853 6.96338 4.59107 7.18918C4.83361 7.41497 5.21326 7.4014 5.43906 7.15886C5.72223 6.85469 6.46199 6.11468 7.14241 5.43973C7.46373 5.12099 7.76855 4.81998 7.9999 4.59191ZM8.42029 8.82192L7.9999 9.25002L7.57952 8.82192C7.81292 8.59273 8.18689 8.59273 8.42029 8.82192ZM7.9999 10.0919C8.23126 10.32 8.53608 10.621 8.8574 10.9397C9.53782 11.6147 10.2776 12.3547 10.5608 12.6589C10.7865 12.9014 11.1662 12.915 11.4087 12.6892C11.6513 12.4634 11.6648 12.0837 11.4391 11.8412C11.1357 11.5153 10.3754 10.7553 9.7025 10.0878C9.36356 9.75157 9.04306 9.43516 8.80734 9.20284L8.42029 8.82192L7.9999 9.25002L7.57952 8.82192L7.19247 9.20284C6.95675 9.43516 6.63625 9.75157 6.29731 10.0878C5.62437 10.7553 4.86414 11.5153 4.56075 11.8412C4.33496 12.0837 4.34853 12.4634 4.59107 12.6892C4.83361 12.915 5.21326 12.9014 5.43906 12.6589C5.72223 12.3547 6.46199 11.6147 7.14241 10.9397C7.46373 10.621 7.76855 10.32 7.9999 10.0919Z"
    />
);

const CollapseDown = () => (
    <TransformGroup rotation="reverse">
        <CollapseUp />
    </TransformGroup>
);

const CollapseRight = () => (
    <TransformGroup rotation="rotate90deg">
        <CollapseUp />
    </TransformGroup>
);

const CollapseLeft = () => (
    <TransformGroup rotation="rotate270deg">
        <CollapseUp />
    </TransformGroup>
);

export const Chevron = {
    Right,
    Left,
    Up,
    Down,
    RightSmall,
    LeftSmall,
    UpSmall,
    DownSmall,
    CollapseUp,
    CollapseDown,
    CollapseRight,
    CollapseLeft,
};
